import MontuLogo from "@/assets/images/montu-logo-light-background.webp";
import { Box } from "@repo/components/src/ui/box";
import { Image } from "@repo/components/src/ui/image";
import { Text } from "@repo/components/src/ui/text";
import React from "react";
import RNAnimated from "react-native-reanimated";

const BrandLoadingScreen = React.memo(() => (
  <Box className="flex-1 items-center justify-center bg-background-50">
    <Box className="items-center gap-6">
      <RNAnimated.View
        style={{
          animationName: {
            from: { opacity: 0.5 },
            to: { opacity: 1 },
          },
          animationDuration: "1.2s",
          animationTimingFunction: "ease-in-out",
          animationIterationCount: "infinite",
          animationDirection: "alternate",
        }}
      >
        <Image
          source={MontuLogo}
          className="w-24 aspect-auto"
          contentFit="contain"
          alt="Montu"
        />
      </RNAnimated.View>
      <Text className="text-sm text-typography-500">Cargando...</Text>
    </Box>
  </Box>
));
BrandLoadingScreen.displayName = "BrandLoadingScreen";

export default BrandLoadingScreen;
